import { StatCard, CardLabel, CardValue, CardUnit, CardSub, ProgressBar, Divider, SubRow, SubStat, SubStatValue, SubStatLabel } from './StatCard'
import useEnvironmentGas from '../../../hooks/useEnvironmentGas'
import useNetworkInfo from '../../../hooks/useNetworkInfo'
import { convertWeiToGwei } from '../../../utils/web3-utils'

export interface Props {
  chainId: number
}

export default function Gas({ chainId }: Props) {
  const { data, isLoading } = useEnvironmentGas(chainId)
  const { data: networkInfo } = useNetworkInfo(chainId)

  if (isLoading || !data) return <StatCard />

  const current = Number(data.currentGas)
  const median = Number(data.medianGas)
  const ok = current <= median
  const percent = median > 0 ? Math.min((current / median) * 100, 200) : 0

  return (
    <StatCard>
      <CardLabel>Gas Price</CardLabel>
      <CardValue>
        {data.currentGas}
        <CardUnit>Gwei</CardUnit>
      </CardValue>
      <CardSub>Median: {data.medianGas} Gwei</CardSub>
      <ProgressBar percent={Math.min(percent, 100)} ok={ok} />
      {networkInfo && (
        <>
          <Divider />
          <SubRow>
            <SubStat>
              <SubStatValue>{networkInfo.executorGasLimitBufferPct || '0'}%</SubStatValue>
              <SubStatLabel>Limit buffer</SubStatLabel>
            </SubStat>
            <SubStat>
              <SubStatValue>
                {networkInfo.gasThresholdAmount ? convertWeiToGwei(networkInfo.gasThresholdAmount) : 0}
              </SubStatValue>
              <SubStatLabel>Threshold gwei</SubStatLabel>
            </SubStat>
          </SubRow>
        </>
      )}
    </StatCard>
  )
}
